<div class="modal" style="display: block;">
    <div class="modal-dialog" [ngClass] = "clsName">
        <div class="modal-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
<div class="modal-backdrop show"></div>